import React, { createContext, useContext, ReactNode, RefObject } from 'react'

interface HeaderActionsContextType {
  headerContainerRef: RefObject<HTMLDivElement> | null
}

const HeaderActionsContext = createContext<HeaderActionsContextType>({ headerContainerRef: null })

interface HeaderActionsProviderProps {
  children: ReactNode
  headerContainerRef: RefObject<HTMLDivElement>
}

export const HeaderActionsProvider: React.FC<HeaderActionsProviderProps> = ({
  children,
  headerContainerRef
}) => {
  return (
    <HeaderActionsContext.Provider value={{ headerContainerRef }}>
      {children}
    </HeaderActionsContext.Provider>
  )
}

export const useHeaderActionsContext = () => {
  const context = useContext(HeaderActionsContext)
  return context
}